module.exports = __webpack_public_path__ + "img/Grenada.4c04f074.gif";